module.exports = __webpack_public_path__ + "img/thomas.94958917.png";